/**
 *  @class
 *  @function FreeShipping
 *
 *  Verfeinert die serverseitig gerenderte Anzeige um den Wechselkurs:
 *  Der Mindestbestellwert steht in Shop-Waehrung, cart.total_price kommt
 *  in der Waehrung des Marktes. Ohne Kurs bleibt der Serverstand stehen -
 *  der ist fuer die Basiswaehrung bereits richtig.
 */

if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    connectedCallback() {
      const total = parseInt(this.dataset.cartTotal, 10);
      const base = parseInt(this.dataset.minimum, 10);

      const rate = parseFloat(
        (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1
      );
      const minimum = Math.round(base * (Number.isFinite(rate) && rate > 0 ? rate : 1));

      // Unbrauchbare Werte: Serverstand unangetastet lassen.
      if (!Number.isFinite(total) || !Number.isFinite(minimum) || minimum <= 0) return;

      const reached = total >= minimum;
      this.classList.toggle('free-shipping--reached', reached);
      this.style.setProperty('--percentage', reached ? 1 : Math.max(total / minimum, 0));
    }
  }
  customElements.define('free-shipping', FreeShipping);
}
